import * as React from 'react';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';

import { DepartureAndArrivalTime } from '.';
import { PhraseType } from 'types/shared';

interface JourneyDetailsProps {
  departureAndArrivalTime: PhraseType;
  differentDayArrival?: string;
  departureAndArrivalAirport: string;
  differentDayArrivalAccessibilityMessage?: string;
}

export const JourneyDetails = ({
  departureAndArrivalTime,
  differentDayArrival,
  differentDayArrivalAccessibilityMessage,
  departureAndArrivalAirport
}: JourneyDetailsProps) => (
  <>
    <div data-test-id="arrival-time">
      <DepartureAndArrivalTime
        departureAndArrivalTime={departureAndArrivalTime}
        differentDayArrival={differentDayArrival}
      />
      {differentDayArrivalAccessibilityMessage && (
        <span className="is-visually-hidden">{differentDayArrivalAccessibilityMessage}</span>
      )}
    </div>
    <UitkLayoutFlex>
      <UitkLayoutFlexItem
        className="uitk-text-primary-theme uitk-type-200 all-t-margin-one truncate"
        minWidth="seventy_two"
      >
        <div data-test-id="arrival-departure">{departureAndArrivalAirport}</div>
      </UitkLayoutFlexItem>
    </UitkLayoutFlex>
  </>
);
